import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useBreadcrumbContext } from "contexts/BreadcrumbContext";

/**
 * Call with the human-readable title for the current dynamic route segment.
 * Internally resolves the active param key and updates the breadcrumb registry.
 * Pages never need to import BreadcrumbContext or know about params.
 *
 * Usage:  usePageTitle(community?.name);
 */
export default function usePageTitle(title) {
  const params = useParams();
  const { setDynamicTitle } = useBreadcrumbContext();

  const paramKey = Object.values(params)[0];

  useEffect(() => {
    if (paramKey && title) {
      setDynamicTitle(paramKey, title);
    }
  }, [paramKey, title, setDynamicTitle]);
}
